import { TrashIcon } from '@heroicons/react/24/outline'
import { MouseEvent } from 'react'

interface IProps {
  filterKey: string
  filterValue: string | boolean
  label: string
  handleRemoveFilter: (e: MouseEvent) => void
}

const RemoveButton = ({
  filterKey,
  filterValue,
  label,
  handleRemoveFilter,
}: IProps) => (
  <button
    data-filter-name={filterKey}
    data-filter-value={filterValue}
    type='button'
    onClick={handleRemoveFilter}
    className='bg-white mb-2 rounded-lg border border-gray-100 py-1 md:py-2 px-2 md:px-3 hover:bg-black hover:text-white mr-2 items-center flex'
  >
    {label}
    <TrashIcon width={16} className='ml-2 pointer-events-none' />
  </button>
)
export default RemoveButton
